import React, { Fragment, ReactNode } from 'react';
import { LinearProgress, LinearProgressProps } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';

import { createSx } from '../../utils';
import { ButtonProps } from '../Button';
import Title from './Title';
import Footer from './Footer';

const sx = createSx({
  content: ({ breakpoints }) => ({
    [breakpoints.down('md')]: {
      width: '90%!important',
      margin: '0 auto',
      padding: 0,
      maxHeight: '100%!important',
    },
  }),
});

interface ModalProps {
  title?: string;
  children: ReactNode;
  modalWidth?: string;
  modalMaxHeight?: string;
  onClose?: () => void;
  onSubmit?: () => void;
  onBack?: () => void;
  submitBtnLabel?: string;
  cancelBtnLabel?: string;
  backBtnLabel?: string;
  submitDisabled?: boolean;
  processing?: boolean;
  hideFooter?: boolean;
  submitBntColor?: ButtonProps['color'];
  linearProgressColor?: LinearProgressProps['color'];
  hideCancelButton?: boolean;
  testID?: string;
}

const ModalWindowContent = ({
  title,
  children,
  modalWidth = '480px',
  modalMaxHeight = '250px',
  onClose,
  onSubmit,
  onBack,
  submitBtnLabel,
  cancelBtnLabel,
  backBtnLabel,
  submitDisabled,
  processing,
  submitBntColor,
  linearProgressColor = 'primary',
  hideFooter,
  hideCancelButton,
  testID,
}: ModalProps) => {

  return (
    <Fragment>
      <Title title={title} onClose={onClose} />
      <DialogContent
        sx={sx.content}
        data-test-id={testID || 'modal-window-content'}
        style={{ width: modalWidth, maxHeight: modalMaxHeight }}
      >
        {children}
      </DialogContent>
      {processing && <LinearProgress color={linearProgressColor} />}
      {!hideFooter && <Footer
        onCancel={onClose}
        onSubmit={onSubmit}
        onBack={onBack}
        submitDisabled={submitDisabled}
        submitBtnLabel={submitBtnLabel}
        cancelBtnLabel={cancelBtnLabel}
        backBtnLabel={backBtnLabel}
        submitBntColor={submitBntColor}
        hideCancelButton={hideCancelButton}
      />}
    </Fragment>
  );
};

export default ModalWindowContent;
